import { useParams } from 'react-router'
import { useSelector } from 'react-redux'
import useFetchData from 'app/_common/hooks/useFetchData'
import useUISelectors from 'app/_common/hooks/useUISelectors'
import UserForm from '../components/UserForm'
import { updateUser, fetchUser } from '../reducers/actions'
import {
	getDisabledPermissions,
	getRoleOptions,
	getUserWithAdditional,
	getIsFetching,
	getError,
} from '../reducers/selectors'
import { fetchRoles } from 'app/admin/roles/reducers/actions'

const EditUser = () => {
	const { id: userId } = useParams()
	const user = useFetchData(
		fetchUser,
		(state) => getUserWithAdditional(state, userId),
		userId,
	)
	const disablePermissions = useSelector((state) =>
		getDisabledPermissions(state, user?.id),
	)
	const roleOptions = useFetchData(fetchRoles, getRoleOptions)
	const ui = useUISelectors(getError, getIsFetching)

	return (
		<UserForm
			user={user}
			submitAction={updateUser}
			title={`Edit user #${user.id || ''}`}
			disablePermissions={disablePermissions}
			roleOptions={roleOptions}
			{...ui}
		/>
	)
}

export default EditUser
